import React, { Component } from 'react'
import classnames from 'classnames'
import { History } from 'history'

import TaskImageComponent from './taskImageComponent'
import TaskDetails from './taskDetails'
import { Task } from './types'

export interface Props {
  task: Task
  history: History
  location: Location
}

export default class TaskWrapper extends Component<Props> {
  static displayName = 'TaskWrapper'

  state = {
    rowLayout: false,
  }

  toggleRowLayout = () => {
    this.setState({ rowLayout: !this.state.rowLayout })
  }

  render() {
    const { task } = this.props
    const { rowLayout } = this.state

    const hasUrl = () => {
      const verifiablesProps = Object.keys(task.verifiables[0])
      if (verifiablesProps.includes('url')) {
        return true
      }
      return false
    }

    return (
      <div>
        {task.verifiables && task.verifiables.length >= 1 && hasUrl() ? (
          <div
            className={classnames('task-wrapper', {
              'task-wrapper--row-layout': rowLayout,
            })}
          >
            <div className="task-wrapper__col-1">
              <TaskImageComponent
                task={task}
                toggleLayout={this.toggleRowLayout}
              />
            </div>
            <div className="task-wrapper__col-2">
              <TaskDetails task={task} />
            </div>
          </div>
        ) : (
          <div className="task-wrapper__col-1">
            <TaskDetails
              task={task}
              history={this.props.history}
              location={this.props.location}
            />
          </div>
        )}
      </div>
    )
  }
}
